import {Editor} from '@tiptap/core'
import StarterKit from '@tiptap/starter-kit'

export default function (content) {
    // Alpine's reactive engine automatically wraps component properties in proxy objects.
    // Attempting to use a proxied editor instance to apply a transaction will
    // cause a "Range Error: Applying a mismatched transaction".
    // We avoid storing the editor as a component property.
    let editor;

    return {
        content: content,
        init(element) {
            editor = new Editor({
                element: element,
                extensions: [StarterKit],
                content: this.content,
                onUpdate: ({editor}) => {
                    this.content = editor.getHTML();
                },
            })

            this.$watch('content', (content) => {
                // If the new content matches TipTap's then we just skip.
                if (content === editor.getHTML()) {
                    return;
                }

                /*
                  Otherwise, it means that a force external to TipTap
                  is modifying the data on this Alpine component,
                  which could be Livewire itself.
                  In this case, we just need to update TipTap's
                  content and we're good to do.
                  For more information on the `setContent()` method, see:
                    https://www.tiptap.dev/api/commands/set-content
                */
                editor.commands.setContent(content, false)
            })
        },
        toggle(control) {
            switch (control) {
                case 'bold':
                    editor.chain().focus().toggleBold().run()
                    break;

                case 'italic':
                    editor.chain().focus().toggleItalic().run()
                    break;

                case 'blockquote':
                    editor.chain().focus().toggleBlockquote().run()
                    break;

                case 'heading':
                    editor.chain().focus().toggleHeading({level: 3}).run()
                    break;

                case 'bullet-list':
                    editor.chain().focus().toggleBulletList().run()
                    break;

                case 'ordered-list':
                    editor.chain().focus().toggleOrderedList().run()
                    break;
            }
        }
    };
};
